import React from 'react';
import { useQuery } from '@apollo/client';
import { Box } from 'rebass';
import { useHistory } from 'react-router-dom';
import useMode from '../../hooks/useMode';
import { useStoreFilters } from '@/hooks/useStoredFilters';
import {
  defaultFilters,
  JobFilters,
} from '@/modes/waterSupplier/pages/hazardSurveys/FilterBarHazardSurvey';
import { gql } from '@/modes/waterSupplier/gql';

const PENDING_REVIEW_QUERY = gql(`
  query HazardSurveysPendingReview {
    hazardSurveysPendingReview: waterHazardSurveys(
      where: { status: "IN_REVIEW" }
      aggregate: [{ col: "jobId", type: DISTINCT, as: "surveys" }]
      limit: null
    ) {
      agg
    }
  }
`);

type PendingReviewData = {
  hazardSurveysPendingReview: {
    agg: {
      surveys: number;
    };
  }[];
};

type HazardSurveysPendingReviewWidgetProps = {
  width: number;
  height: number;
};

const HazardSurveysPendingReviewWidget = ({
  width,
  height,
}: HazardSurveysPendingReviewWidgetProps): JSX.Element => {
  const { data } = useQuery<PendingReviewData>(PENDING_REVIEW_QUERY, {
    fetchPolicy: 'no-cache',
  });

  const history = useHistory();
  const mode = useMode();

  const storeFilters = useStoreFilters<JobFilters>(
    'waterSupplierHazardSurveys'
  );

  return (
    <>
      {data && (
        <Box
          sx={{
            flexGrow: 1,
            textAlign: 'center',
            fontSize: height * 0.7,
            lineHeight: 1.4,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8,
            },
          }}
          onClick={() => {
            storeFilters({
              ...defaultFilters,
              status: ['IN_REVIEW'],
            });
            history.push(`/${mode}/hazard-surveys`);
          }}
        >
          {data.hazardSurveysPendingReview[0]?.agg.surveys ?? 0}
        </Box>
      )}
    </>
  );
};

export default HazardSurveysPendingReviewWidget;
